@use "foundation/_colors.scss";


.form-width {
  display: inline-block;
  width: 100%;
}

.button-right {
  margin: 1.2em 0 !important;
  float: right;
}

.invite-confirmation {
  display: flex;
  flex-direction: column;
  background-color: #eee;
  padding: 2em;
  align-items: center;
  border-radius: 10px;
  margin-top: 2em;
}

.side-by-side {
  display: flex;
}

.button-margin {
  margin: 0 10px !important;
}

.center-text {
  text-align: center;
}

.section-margin {
  margin-top: 1.5em;
}

.divider {
  height: 0;
  width: 100%;
  margin-top: 2em;
  border-bottom: 3px solid #f5f5f5;
}

.cursor {
  cursor: pointer;
}

a.contact-us {
  text-decoration: underline;
  color: colors.$primary-text-color;
}
